import { createContext } from 'react';
import type { PlatoUserInContext } from '../../../utils/plato-user.ts';

// this should be away from the plato-user-layout component, so it doesn't get
// recreated on HMR
export const PlatoUserContext = createContext<PlatoUserInContext | undefined>(undefined);
